// Condition tiers — segmented tab filter (Toate / Noi / Recondiționate).
// Stateful (active tab) → custom element per cos-* convention.
//
// Filters .cos-slider__item by data-group via a data-filter attribute on the
// host (CSS hides non-matching items with display:none). After each switch it
// resets the slider to the start, which also lets cos-slider recompute its
// arrow visibility for the new — possibly non-overflowing — item set.
//
// Arrows are only ever clickable in the "Toate" state (full set, nothing
// hidden); filtered subsets either fit (arrows auto-hide) or are on touch
// (arrows hidden), so cos-slider's hidden-item index math is never exercised.
export class CosConditionTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('.condition-tabs__tab'));
    this.sliderEl = this.querySelector('cos-slider');
    if (!this.tabs.length) return;

    this.onClick = (e) => {
      const tab = e.target.closest('.condition-tabs__tab');
      if (tab && this.contains(tab)) this.select(tab);
    };

    // Roving-tabindex keyboard nav for the tablist (ArrowLeft / ArrowRight).
    this.onKeydown = (e) => {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      const i = this.tabs.indexOf(document.activeElement);
      if (i === -1) return;
      e.preventDefault();
      const dir = e.key === 'ArrowRight' ? 1 : -1;
      const next = this.tabs[(i + dir + this.tabs.length) % this.tabs.length];
      next.focus();
      this.select(next);
    };

    this.addEventListener('click', this.onClick);
    this.addEventListener('keydown', this.onKeydown);
  }

  disconnectedCallback() {
    if (this.onClick) this.removeEventListener('click', this.onClick);
    if (this.onKeydown) this.removeEventListener('keydown', this.onKeydown);
  }

  select(tab) {
    const filter = tab.dataset.filter || 'all';

    this.tabs.forEach((t) => {
      const active = t === tab;
      t.classList.toggle('condition-tabs__tab--active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
      t.tabIndex = active ? 0 : -1;
    });

    this.setAttribute('data-filter', filter);

    // Reset scroll + recompute arrow visibility for the new item set.
    // scrollToStart() is a public cos-slider method ending in updateControls().
    if (this.sliderEl && typeof this.sliderEl.scrollToStart === 'function') {
      this.sliderEl.scrollToStart();
    } else {
      const scroller = this.querySelector('.cos-slider');
      if (scroller) scroller.scrollTo({ left: 0, behavior: 'auto' });
    }
  }
}

if (!window.customElements.get('cos-condition-tabs')) {
  window.customElements.define('cos-condition-tabs', CosConditionTabs);
}
